module.exports = __webpack_public_path__ + "static/media/default-team-img.901f82ca.svg";